import React, { useEffect, useState } from 'react';
import { RenderPage } from '@/src/render';
import { store } from '@/src/store/configure';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import styled from 'styled-components';
import { ChartDetails } from './components/ChartDetails';
import { updateExchangeAndCocode } from '@/src/store/reducers/stocks/stockDetailsSlice';

const Container = styled.div`
  width: 100%;
`;

export const GraphSection = () => {
  const dispatch = useDispatch();
  const [exchange, setExchange] = useState<string | null>(null);
  const [exchanges, setExchanges] = useState<string | null>(null);
  const [cocode, setCocode] = useState<string | null>(null);

  const extractAttributes = () => {
    const element = document.getElementById('csr-stock-details-page');
    setExchange(element?.getAttribute('data-exchange') ?? null);
    setExchanges(element?.getAttribute('data-exchanges') ?? null);
    setCocode(element?.getAttribute('data-cocode') ?? null);
  };

  useEffect(() => {
    extractAttributes();
  }, []);

  useEffect(() => {
    if (exchange || exchanges || cocode) {
      dispatch(
        updateExchangeAndCocode({
          exchange,
          exchanges,
          cocode,
        }),
      );
    }
  }, [dispatch, exchange, exchanges, cocode]);

  return (
    <Container>
      <ChartDetails />
    </Container>
  );
};

RenderPage(
  'csr-stock-graph-section',
  <Provider store={store}>
    <BrowserRouter>
      <GraphSection />
    </BrowserRouter>
  </Provider>,
);
